export default "__VITE_ASSET__Bdgm96Hq__"